<script>
  import Tailwind from "../Tailwind.svelte";
  import Departures from "./Departures.svelte";
  import Message from "../Message.svelte";
  import Clock from "../Clock.svelte";
  
  import { parseSystemUrl } from "../environments";

  let error = undefined;
  let stops = undefined;
  let limit = undefined;
  let style = undefined;
  let type = undefined;
  let show_clock = true;
  let show_date = false;
  let systemUrl = undefined;

  let currDate = 0;

  try {
    const hostname = window.location.hostname
    systemUrl = parseSystemUrl(hostname)

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let stopString = urlParams.get("stops");
    stops = stopString.split(",");
    limit = urlParams.get("limit");
    limit = isNaN(parseInt(limit)) ? 10 : parseInt(limit);
    style = urlParams.get("style");
    style = isNaN(parseInt(style)) ? 1 : parseInt(style);
    // 0 - 800x480 - ecrã gigante
    // else - default (1920x1080) - TV
    type = (urlParams.get("type") === 'departures' || urlParams.get("type") === 'arrivals') ? urlParams.get("type") : 'departures';

    // Backwqard compatibility for url with stops=VNF*****
    stops = stops.map(str => str.replace(/^VNF/, "MOB"));
  } catch (e) {
    console.log(e);
  }
</script>

<Tailwind/>

{#if style == 0}
  <div class="bg-black text-white h-screen w-screen overflow-hidden font-2">
    <div class="grid grid-cols-frame grid-rows-frame h-full w-full">
      <div class="row-start-1 row-end-3 col-start-1 col-end-12  overflow-hidden px-3 py-0">
        {#if stops && !error}
          <div class="bg-black flex flex-row h-full w-full space-x-2 overflow-hidden">
            {#each stops as id}
              <Departures {id} {limit} {style} {type} {systemUrl}/>
            {/each}
          </div>
        {:else}
          <Message
            title="Iremos ser breves..."
            text="Estamos com alguns problemas a mostrar a informação"
          />
        {/if}
      </div>
    </div>
  </div>
{:else}
  <div class="bg-black text-white h-screen w-screen overflow-hidden font-1">
    <div class="grid grid-cols-frame grid-rows-frame h-full w-full">
      <div class="row-start-1 row-end-2 col-start-1 col-end-12  overflow-hidden p-5">
        {#if stops && !error}
          <div class="bg-black flex flex-row h-full w-full space-x-2 overflow-hidden">
            {#each stops as id}
              <Departures {id} {limit} {style} {type} {systemUrl}/>
            {/each}
          </div>
        {:else}
          <Message
            title="Iremos ser breves..."
            text="Estamos com alguns problemas a mostrar a informação"
          />
        {/if}
      </div>
      <div class="row-start-2 row-end-4 col-span-full bg-primary p-5 h-24 flex justify-between items-center">
        <div class="flex items-center">
          <img class="logo" alt="Logo Qmob" src="img/logo_white.png">
        </div>
        <div class="inline-flex">
          <span class="text-5xl text-white text-right">
            <Clock {currDate} {show_clock} {show_date}/>
          </span>
        </div>
      </div>
    </div>
  </div>
{/if}
